import React from "react";
import PropTypes from 'prop-types';
import OfferClock from 'images/icons/access-alarms-material.png';
import Link from 'components/Link';
import Categories from 'components/Home/TodayOffers/Categories';
import ProductOffersTodayContainer from 'containers/ProductOffersToday';
import TagManagerService from 'services/TagManager';
import CMSFactory from "factories/CMS";
import { sliderProductsTxt } from 'config/translate/variables';
import style from './style.scss';//NOSONAR

const SliderTodayOffers = ({ item, date }) => {
    if(!item) return '';
    let content = item.content ? item.content : [];
    let url = item.url ? item.url : '';
    let urlTarget = item.url_target ? item.url_target : '';
    let dateServer = date;

    const clickTagManager = () => {
        TagManagerService.clickLink(sliderProductsTxt.viewMore, 'Products-Offers', item.title);
    }

    return (
        <section className="today-offers-container">
            <div className="today-offers-wrap">
                <h1 className="today-offers-title">
                    <img src={OfferClock} className="today-offers-icon" alt="offers icon"/>
                    <strong>{item.title}</strong>
                </h1>
                <Link className="new-link home-section-link" to={url} target={urlTarget} onClick={() => clickTagManager()}>
                    {sliderProductsTxt.viewMore}
                </Link>
            </div>
            <div className="today-offers-container-item"> 
                {content && content.length && content.map((element, i) => {
                    if (element.acf_fc_layout) {
                        switch (element.acf_fc_layout) {
                            case 'categories': 
                            {   
                                let category = element.category ? element.category : null;
                                let dateValidate = true;
                                let startDate = content[0].start_date ? CMSFactory.milliseconds(content[0].start_date) : '';
                                let endDate = content[0].end_date ? CMSFactory.milliseconds(content[0].end_date) : '';
                                if (startDate && (startDate >= dateServer)) dateValidate = false;
                                if (endDate && (endDate <= dateServer)) dateValidate = false;
                                if(!content[0].active) dateValidate = false;
                                return <Categories categories={category} key={i} id={i} active={dateValidate} isLoading={!element.category} shelfIsland={item.shelfIsland}/>; 
                            } 
                            case 'product': 
                            {
                                if(element.active !== true) return;
                                let startDate = CMSFactory.milliseconds(element.start_date);
                                let endDate = CMSFactory.milliseconds(element.end_date);
                                if (startDate && (startDate >= dateServer)) return false; 
                                if(endDate && (endDate <= dateServer)) return false;
                                return  <ProductOffersTodayContainer item={element} key={i} title={item.title} position={item.countProductOffers} shelfIsland={item.shelfIsland}/> 
                            } 
                            default: 
                                return ''; 
                        }
                    }

                })}
            </div>
        </section>
    )
}
SliderTodayOffers.propTypes = {
    item: PropTypes.object,
    date: PropTypes.number,
    shelfIsland: PropTypes.number
}
export default SliderTodayOffers;
